import React from 'react';
import TextField from '@mui/material/TextField';
import logo from "../images/indice.svg";
import Button from '@mui/material/Button';
import { withRouter } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import useToken from "../useToken";
import { loginResources } from "../endpoints";
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { FormControl, InputLabel, OutlinedInput, Grid, Typography } from "@mui/material";
import jwt from "jwt-decode";

class FormLogin extends React.Component {
    state = {
        error: false,
        rut: "",
        password: "",
        showPassword: false
    };

    getEventType = (event) => {
        if (event.keyCode === 13) {
            if (this.state.rut && this.state.password) {
                this.handleClick();
            }
        }
    }

    componentDidMount() {
        document.addEventListener('keyup', this.getEventType, false);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    handleClick = () => {
        loginResources.login(this.state)
            .then(async response => {
                if (!response.ok) throw new Error("Login error");
                return await response.json();
            })
            .then(data => {
                const token = data.access_token;
                if (!token) {
                    this.setState({ error: true });
                    return;
                }

                localStorage.setItem('token', token);

                // ✅ decodificas el token aquí
                const user = jwt(token);

                 if (user.perfil === 'analista oficina sodimac') {
                    this.props.history.push('/panel_sodimac_diario');
                }
                else if (user.perfil === 'analista smu perecible') {
                    this.props.history.push('/panel_auditorias');
                }
                else {
                    this.props.history.push('/inventarios');
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({ error: true });
            });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    verifyRoute = () => {
        const verifyToken = useToken.verifyExpToken();
        if (verifyToken) {
            return this.props.history.push('/avance');
        } else {
            localStorage.removeItem('token');
            localStorage.removeItem("datos");
        }
    }

    handleClickShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }

    handleMouseDownPassword = (event) => {
        event.preventDefault();
    }

    render() {
        this.verifyRoute();

        return (
            <Grid
                container
                direction="column"
                alignContent="center"
                justifyContent="center"
                sx={{ minHeight: '100vh' }}
            >
                <Grid item container direction="row" alignContent="center" spacing={2} xs={6}>
                    <form
                        noValidate
                        autoComplete="off"
                        style={{ display: 'contents' }}
                    >
                        <Grid item container justifyContent="center" direction="row">
                            <img src={logo} alt="" height={window.innerHeight * 0.12} />
                        </Grid>
                        <Grid item container justifyContent="center" direction="row">
                            <Typography sx={{ mt: 1 }} variant="h6">
                                Ingresar
                            </Typography>
                        </Grid>
                        <Grid item container justifyContent="center" direction="row">
                            <TextField
                                label="Rut sin dígito"
                                variant="outlined"
                                name="rut"
                                onChange={this.handleChange}
                                value={this.state.rut}
                                autoFocus
                                sx={{ m: 1, minWidth: '25ch', width: '50ch' }}
                            />
                        </Grid>
                        <Grid container justifyContent="center" direction="row">
                            <FormControl
                                variant="outlined"
                                sx={{ m: 1, minWidth: '25ch', width: '50ch' }}
                            >
                                <InputLabel>Contraseña</InputLabel>
                                <OutlinedInput
                                    type={this.state.showPassword ? 'text' : 'password'}
                                    value={this.state.password}
                                    name="password"
                                    label="Contraseña"
                                    onChange={this.handleChange}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={this.handleClickShowPassword}
                                                onMouseDown={this.handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Grid>
                        <Grid item container justifyContent="center" direction="row">
                            {this.state.error && (
                                <Alert severity="error" sx={{ mt: 1 }}>
                                    Rut usuario o contraseña incorrectos.
                                </Alert>
                            )}
                        </Grid>
                    </form>
                    <Grid item container justifyContent="center" direction="row">
                        <Button
                            disabled={!this.state.rut || !this.state.password}
                            size="large"
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2 }}
                            onClick={this.handleClick}
                        >
                            Ingresar
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(FormLogin);
